import { Language } from '@reach/interfaces/user/language.enum';

import { ReachTranslateLang } from '../types/language';

export const i18nMap: Record<Language, ReachTranslateLang> = {
	[Language.EN_GB]: ReachTranslateLang.ENGLISH_GB,
	[Language.ES_ES]: ReachTranslateLang.SPANISH_SPAIN,
	[Language.FR_FR]: ReachTranslateLang.FRENCH_FRANCE,
};
